// Record looks like a table within a relational Database.

type Persons = Record<string, { name: string; role: string }>;

export const RecordPersons: Persons = {} as const;
RecordPersons['000'] = { name: 'Hsu Ye Ywel', role: 'Admin' };
RecordPersons['111'] = { name: 'Thuta Sann', role: 'Developer' };
// RecordPersons['222'] = { name: 'Pyae Thuta' }; // <--- Error: Missing Property `role`
